import { createStore } from 'vuex';

export default createStore({
  state: {
    isDarkMode: localStorage.getItem('theme') === 'dark' || false,
  },
  mutations: {
    toggleTheme(state) {
      state.isDarkMode = !state.isDarkMode;
      localStorage.setItem('theme', state.isDarkMode ? 'dark' : 'light');
      // Update meta theme color
      const metaThemeColor = document.querySelector('meta[name="theme-color"]');
      if (metaThemeColor) {
        metaThemeColor.setAttribute(
          'content',
          state.isDarkMode ? '#131313' : '#ffffff'
        );
      }
    },
    setTheme(state, isDark) {
      state.isDarkMode = isDark;
      localStorage.setItem('theme', state.isDarkMode ? 'dark' : 'light');
      // Update meta theme color
      const metaThemeColor = document.querySelector('meta[name="theme-color"]');
      if (metaThemeColor) {
        metaThemeColor.setAttribute(
          'content',
          state.isDarkMode ? '#131313' : '#ffffff'
        );
      }
    },
  },
  actions: {
    initializeTheme({ commit }) {
      const savedTheme = localStorage.getItem('theme');
      if (savedTheme) {
        commit('setTheme', savedTheme === 'dark');
      } else if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        commit('setTheme', true);
      }
    },
  },
});